import { useEffect, useState } from 'react'
import { checkOverTime } from '../utils'
import { useSelector } from 'react-redux'
import useDidMountEffect from './useDidMountEffect';

const useTimeWork = props => {
    const agreeOvertime = useSelector(state => state.AppReducer.agreeOvertime);
    const isReady = useSelector(state => state.RestaurantReducer.isReady);
    const [isOvertime, setIsOvertime] = useState(isReady === false || checkOverTime())

    useEffect(() => {
        // settimeout check over time
    }, [])

    useDidMountEffect(() => {
        if (props?.useAgreeOvertime && agreeOvertime) {
            setIsOvertime(false)
        }
    }, [ agreeOvertime ])

    return { isOvertime }
}

export default useTimeWork
